import { Stack } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import { DocumentSearchItem } from '@/entities/DocumentsSearch';
import { useSearchSortTransition } from '@/hooks/useSearchSortTransition';
import { type DocumentSearchSortBy, sortDocumentSearchItems } from '@/utils/sortDocumentSearchItems';

import s from './SearchSortedItemsTransition.module.scss';

type Props = {
  items: readonly DocumentSearchItem[];
  sortBy: DocumentSearchSortBy;
  className?: string;
  children: (sortedItems: DocumentSearchItem[]) => React.ReactNode;
};

const SearchSortedItemsTransition: React.FC<Props> = ({ items, sortBy, className, children }) => {
  const { reduceMotion, displayedSortBy, visible, handleTransitionEnd } = useSearchSortTransition(sortBy);

  if (reduceMotion) {
    const sorted = sortDocumentSearchItems(items, sortBy);

    return (
      <Stack className={className} gap="xxs">
        {children(sorted)}
      </Stack>
    );
  }

  const sorted = sortDocumentSearchItems(items, displayedSortBy);

  return (
    <Stack className={cn(className, s.root, !visible && s.root_hidden)} gap="xxs" onTransitionEnd={handleTransitionEnd}>
      {children(sorted)}
    </Stack>
  );
};

export default SearchSortedItemsTransition;
